var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mixchart",staticClass:"mt-5",staticStyle:{"width":"100%","height":"400px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }